<template>
    <v-dialog v-model="show_dialog" ref="save_story_dialog" scrollable persistent max-width="600px" :fullscreen="$vuetify.breakpoint.smAndDown" :content-class="dialog_class">
        <v-form ref="saveStoryForm" method="post" :action="form.action" v-model="form.valid" v-on:success="success_save_event" v-on:before_submit="before_send_event">
            <v-card>
                <v-card-title
                    class="headline blue darken-2 white--text"
                >
                    <div v-if="form.data.story_id > 0">{{$t('event.edit_story')}}</div>
                    <div v-else>{{$t('event.create_story')}}</div>
                </v-card-title>
                <v-card-text class="v-dialog-body">
                    <input type="hidden" name="event_id" v-model="event_id">
                    <input type="hidden" name="story_id" v-model="form.data.story_id">
                    <input type="hidden" name="story_media_type" v-model="form.data.story_media_type">

                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 v-if="form.errors.general!==''">
                                <v-alert
                                        :value="form.errors.general!==''"
                                        type="error"
                                >
                                    {{form.errors.general}}
                                </v-alert>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field
                                    :label="$t('event.story_title')"
                                    append-icon="font_download"
                                    v-model="form.data.story_title"
                                    :rules="[rules.required]"
                                    :error-messages="form.errors.title"
                                    name="title"
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <label class="v-label sp-v-label">
                                    Media type
                                </label>

                                <div>
                                    <v-btn-toggle v-model="form.data.story_media_type" mandatory>
                                        <v-btn flat :value="1">
                                            {{$t('media_type.vr_image')}}
                                        </v-btn>
                                        <v-btn flat :value="2">
                                            {{$t('media_type.normal_image')}}
                                        </v-btn>
                                    </v-btn-toggle>
                                </div>

                            </v-flex>

                            <v-flex xs12
                                v-show="form.data.story_media_type == 1"
                            >
                                <v-text-field
                                    :label="$t('event.story_auto_tour_speed')"
                                    v-model="form.data.story_auto_tour_speed"
                                    name="auto_tour_speed"
                                    type="number"
                                    min="0"
                                    :suffix="$t('units.second')"
                                    :hint="$t('event.story_auto_tour_speed_desc')"
                                    persistent-hint
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12
                                v-show="form.data.story_media_type == 1"
                            >
                                <v-text-field
                                    :label="$t('event.story_scene_rotate_time')"
                                    v-model="form.data.story_scene_rotate_time"
                                    name="scene_rotate_time"
                                    type="number"
                                    min="0"
                                    :suffix="$t('units.second')"
                                    :hint="$t('event.story_scene_rotate_time_desc')"
                                    persistent-hint
                                ></v-text-field>
                            </v-flex>

                            <v-flex xs12 class="mt-2">
                                <div>
                                    <label class="v-label sp-v-label">
                                        {{$t('event.media')}}
                                    </label>
                                </div>
                                <div>
                                    <v-btn class="ml-0" @click="insertMedia">{{$t('event.insert_media')}}</v-btn>
                                </div>

                                <draggable
                                        class="list-group"
                                        tag="ul"
                                        v-model="form.data.story_media"
                                        v-bind="dragOptions"
                                        @start="drag = true"
                                        @end="drag = false"
                                        handle=".drag-handle"
                                >
                                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                        <li
                                                class="list-group-item"
                                                v-for="media_id in form.data.story_media"
                                                :key="media_id"
                                        >
                                            <v-layout align-center>
                                                <v-flex>
                                                    <v-layout align-center>
                                                        <v-flex class="drag-handle_wrapper">
                                                            <v-icon class="drag-handle">fas fa-arrows-alt-v</v-icon>
                                                        </v-flex>
                                                        <v-flex class="">
                                                            <v-img width="60" height="35" @click="showImgLightBox(media_list[media_id].file.absolute_url)" :src="getThumbnailUrl(media_list[media_id].file.absolute_url)" class="story-image"></v-img>
                                                        </v-flex>
                                                        <v-flex class="drag-item-title">
                                                            {{ media_list[media_id].name }}
                                                        </v-flex>
                                                        <v-spacer></v-spacer>
                                                    </v-layout>

                                                </v-flex>
                                                <v-spacer></v-spacer>
                                                <v-btn flat icon @click="removeStoryMedia(media_id)">
                                                    <v-icon>delete</v-icon>
                                                </v-btn>
                                            </v-layout>

                                        </li>
                                    </transition-group>
                                </draggable>

                            </v-flex>

                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="close_dialog">{{$t('action.close')}}</v-btn>
                    <v-btn color="blue darken-1" flat type="submit" :loading="form.loading" :disabled="!form.valid">{{$t('action.save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>

        <VueEasyLightbox
                :visible="imgLightBox.visible"
                :imgs="imgLightBox.img"
                :index="imgLightBox.index"
                @hide="hideImgLightBox"
        >
        </VueEasyLightbox>

        <media-picker
                v-model="media_picker.show"
                :exclude="form.data.story_media"
                :eventId="event_id"
                :mediaType="form.data.story_media_type"
                @success="getMedia"
        ></media-picker>
    </v-dialog>
</template>

<script>
    import {UrlServices} from "~/utils/url-manager";
    import FormHandling from "~/utils/data/form-handling";
    import MediaPicker from "~/components/event/media/MediaPicker";
    import draggable from "vuedraggable";
    import VueEasyLightbox from 'vue-easy-lightbox'
    import OssStyler from "~/utils/images/oss-styler";

    export default {
        name: "SaveStoryDialog",
        components: {
            MediaPicker,
            draggable,
            VueEasyLightbox
        },
        props: {
            event_id: Number,
            show_dialog: Boolean,
            save_success_callback: Function,
            story_item: [Object, Boolean],
            media_list: Object
        },
        data() {
            return {
                dialog_class: "",
                media_picker: {
                    show: false,
                    eventId: 0,
                },
                form: {
                    form_handling_object: null,
                    action: UrlServices.createUrl({name: "api_event_story_save"}),
                    loading: false,
                    valid: false,
                    data: {
                        story_id: 0,
                        story_title: "",
                        story_media_type: 1,
                        story_auto_tour_speed: "",
                        story_scene_rotate_time: "",
                        story_media: []
                    },
                    errors: {
                        general: "",
                        title: "",
                        story_media: ""
                    }
                },
                rules: {
                    required: value => (!!value) || this.$t('form.field_required'),
                },
                drag: false,
                imgLightBox: {
                    img: '',
                    visible: false,
                    index: 0
                }
            }
        },
        beforeCreate() {
            this.empty_story_item = {
                id: 0,
                title: "",
                story_media_type: 1,
                media: [],
                auto_tour_speed: "",
                scene_rotate_time: ""
            };
        },
        methods: {
            insertMedia() {
                this.media_picker.show = true;
            },
            getMedia(media) {
                this.form.data.story_media = this.form.data.story_media.concat(_.map(media, 'id'));
                this.updateStoryMedia();
                this.media_picker.show = false;
            },
            updateStoryMedia() {
                let me = this;
                _.remove(this.form.data.story_media, function(media_id) {
                    return me.media_list[media_id].type != me.form.data.story_media_type;
                });
            },
            removeStoryMedia(media_id) {
                _.remove(this.form.data.story_media, (current_value) => {
                    return current_value == media_id;
                });
                this.form.data.story_media = _.extend([], this.form.data.story_media);
            },
            success_save_event(data) {
                this.save_success_callback(data);
                this.close_dialog();
            },
            before_send_event() {
                let me = this;
                _.each(this.form.data.story_media, function(value){
                    me.form.form_handling_object.addAdditionalParam('story_media[]', value);
                });
            },
            close_dialog() {
                this.$emit('update:show_dialog', false);
            },
            showImgLightBox(url) {
                this.imgLightBox.img = url;
                this.imgLightBox.visible = true;
                this.dialog_class = "not-scrollable";
            },
            hideImgLightBox() {
                this.imgLightBox.visible = false;
                this.dialog_class = "";
            },
            getThumbnailUrl(url) {
                // return "https://images.weserv.nl/?url=" + url + "&w=400";
                return OssStyler.getThumbnailResUrl(url);
            },
        },
        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            }
        },
        watch: {
            story_item: async function(new_story_item) {
                if(new_story_item == null){
                    new_story_item = _.extend({}, this.empty_story_item);
                    this.form.form_handling_object.formReset();
                    await this.$nextTick();     // Delay the following code so that bindings happen after the form is cleared
                }

                if(new_story_item.auto_tour_speed == 0){
                    new_story_item.auto_tour_speed = "";
                }

                if(new_story_item.scene_rotate_time == 0){
                    new_story_item.scene_rotate_time = "";
                }

                this.form.data = {
                    story_id: new_story_item.id,
                    story_title: new_story_item.name,
                    story_media_type: parseInt(new_story_item.story_media_type),
                    story_media: _.map(new_story_item.media, 'media_id'),
                    story_auto_tour_speed: new_story_item.auto_tour_speed,
                    story_scene_rotate_time: new_story_item.scene_rotate_time,
                };

            },
            "form.data.story_media_type": function(val) {
                this.updateStoryMedia();
            },
        },
        mounted() {
            this.form.form_handling_object = new FormHandling(this, "saveStoryForm");
        }
    }
</script>

<style>
    .not-scrollable {
        overflow: hidden;
    }

    .v-label.sp-v-label {
        font-size: 0.9em;
        color: #AAA;
    }

    ul.list-group {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
        -ms-flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        padding-left: 0;
        margin-bottom: 0;
    }

    li.list-group-item {
        position: relative;
        display: block;
        padding: .75rem 1.25rem;
        margin-bottom: -1px;
        background-color: #fff;
        border: 1px solid rgba(0,0,0,.125);
    }

    .list-group .story-image {
        display: inline-block;
    }

    .drag-item-title {
        width: 100%;
    }

    .drag-handle_wrapper {
        width: 30px;
    }
</style>